import EventBus from "./EventBus";

export type ToastColor = "success" | "error" | "warning" | "info";

export interface ToastPayload {
  message: string;
  color: ToastColor;
  timeout?: number;
}

export function showToast(message: string, timeout?: number, color: ToastColor = "success") {
  EventBus.$emit("toast", { message, color, timeout } as ToastPayload);
}

export function toastSuccess(message: string) {
  showToast(message, 4000, "success");
}

export function toastError(message: string) {
  showToast(message, -1, "error");
}

export function toastInfo(message: string) {
  showToast(message, 5000, "info");
}
